import { render, staticRenderFns } from "./UserRecycleBinModal.vue?vue&type=template&id=36eb7e79&scoped=true&"
import script from "./UserRecycleBinModal.vue?vue&type=script&lang=js&"
export * from "./UserRecycleBinModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eb7e79",
  null
  
)

export default component.exports